import React, { Component } from 'react';
import "./global.css";

export default class LoadSpinner extends Component {
	render() {
		return <div className="global_loadspinner"></div>;
	}
}